import * as React from 'react';
import { connect } from 'react-redux';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { POLICY_DETAILS, DASHBOARD, FNOL_SUBMIT_CLAIM } from '../../routes/routes';
//import ClaimCapture from './ClaimCapture';
import { navigateTo } from '../../actions/navigationActions';
import { Image, Button, Card } from 'react-bootstrap';
import { showCallMeModal } from '../../actions/modalActions';
import { setStep } from '../../actions/claimSubmitActions';
import { setSelectedCover } from '../../actions/profileActions';

class ClaimProgressCard extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.getNrImageSrc = this.getNrImageSrc.bind(this);
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    handleCoverRedirect() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            this.props.redirectTo(POLICY_DETAILS);
        }
    }

    handleClick(step, subStep, isDone) {
        if (step <= this.props.claimSubmit.selectedClaimStep.step && this.props.claimSubmit.selectedClaimStep.title !== 'Complete') {
            this.props.dispatchSetStep(parseInt(step), parseInt(subStep));
                this.props.redirectTo(FNOL_SUBMIT_CLAIM);
        }
    }

    getNrImageSrc() {
        let src = "";
        if (this.props.isSelected) {
            src = "/my-policy/Images/Claims/Numbers/" + this.props.stepLabel + "-red.png";
        }

        if (this.props.done) {
            src = "/my-policy/Images/icon-checkmark-nugreen-32px-32px.svg";
        }

        if (!this.props.isSelected && !this.props.done) {
            src = "/my-policy/Images/Claims/Numbers/" + this.props.stepLabel + "-grey.png";
        }

        return src;
    }

    getArrowSrc() {
        let arrowsrc = "";
        if (this.props.isSelected) {
            arrowsrc = "/my-policy/Images/Claims/dropdown-red.png";
        }

        if (this.props.done) {
            arrowsrc = "/my-policy/Images/Claims/dropdown-grey.png";
        }

        if (!this.props.isSelected && !this.props.done) {
            arrowsrc = "/my-policy/Images/Claims/dropdown-silver.png";
        }
        return arrowsrc;
    }

    public render() {
        const { profile } = this.props;
        let cardId = (this.props.profile.selectedPersonalCover !== null ? this.props.profile.selectedPersonalCover.id : "0");
        return (
            <div className="fnol-progress-claim-card" id="ProgressCard">
                <Card className={(this.props.id === cardId ? 'isClicked ' : '')} onClick={() => this.handleClick(this.props.nr,this.props.id,this.props.done)}>
                    <Card.Body>
                        <div className="row align-items-center">
                            <div className="fnol-progress-claim-card-col-img align-self-center">
                                <img src={this.getNrImageSrc()} alt="" title="" />
                            </div>
                            <div className="col align-self-center fnol-progress-claim-card-col-center">
                                <p className={(this.props.isSelected || this.props.done) ? "fnol-progress-claim-card-col-header " : "fnol-progress-claim-card-col-header text-disabled"}>{this.props.title.replace('&', '')}</p>
                                <p className={(this.props.isSelected ? 'fnol-progress-claim-card-col-subtext' : 'd-none')}>{this.props.subTitle}</p>
                            </div>
                            <div className="fnol-progress-claim-card-col-arrow align-self-center">
                                <img src={this.getArrowSrc()} alt="" title="" />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchSetSelectedCover: (id) => dispatch(setSelectedCover(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimProgressCard);